import { Icon } from "@mdi/react";
import { useDispatch } from "react-redux";

import { mdiSelectionSearch } from "@mdi/js";
import { zoomToFilterResults } from "store/features/filter/zoomToFilterResults";
import styled from "styled-components";

import { ToolbarButton } from "components/base";
import { useUserContext } from "components/user/context";
import { updateZoomToFilterSetting } from "components/user/context/reducer/UserReducer";
import { useUserSettings } from "components/user/hooks";

const label = "Zoom to Filtered Results";

export default function ZoomToFilter() {
  const [, dispatch] = useUserContext();
  const reduxDispatch = useDispatch();
  const { zoomToFilterSetting } = useUserSettings();
  const active = zoomToFilterSetting?.isZoomToFilterEnabled ?? false;

  // Session-only setting: it lives in context, starts off on every load, and is
  // never persisted. Dispatch is synchronous, so the button reflects the flip on
  // the next render without any local state.
  return (
    <ToolbarButton
      active={active}
      testId="zoom-to-filter"
      icon={
        <IconWrapper>
          <Icon path={mdiSelectionSearch} size={"20px"} />
        </IconWrapper>
      }
      onToggle={(v) => {
        updateZoomToFilterSetting(dispatch, { isZoomToFilterEnabled: v });
        // Switching the toggle on zooms right away instead of waiting for the
        // next filter change.
        if (v) {
          reduxDispatch(zoomToFilterResults());
        }
      }}
      overflowLabel={label}
      styleKey="miniMapToolbar"
      tooltipPlacement="left"
      tooltipText={label}
    />
  );
}

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
